import React from "react";
import { ReactComponent as CheckIcon } from "assets/img/svg/CheckIcon.svg";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";

const FailedStateCard = ({ retryHandler, paymentMode = "Card" }) => {
  return (
    <div
      className=" d-flex flex-column align-items-center justify-content-center"
      style={{ minHeight: "212px" }}
    >
      <span
        className=" d-flex align-items-center justify-content-center"
        style={{
          backgroundColor: "#DC2804",
          border: "1px",
          borderRadius: "50%",
          width: "56px",
          height: "56px",
        }}
      >
        <CheckIcon />
      </span>
      <div className="mt-2 dark-text label-color">
        {paymentMode} Payment Failed!
      </div>
      <div
        className="mt-2 mb-2"
        style={{ fontWeight: 400, fontSize: "16px", lineHeight: "28px" }}
      >
        Please try again
      </div>
      <AButton
        updatedStyle={{ width: "206px" }}
        variant={"primary_filled"}
        onClick={retryHandler}
      >
        Re-try
      </AButton>
    </div>
  );
};
export default FailedStateCard;
